import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Get admin token from localStorage
export const getAdminToken = () => {
  return localStorage.getItem("adminToken");
};

// Check if admin is logged in
export const isAdminLoggedIn = () => {
  return !!getAdminToken();
};

// Logout admin
export const logoutAdmin = () => {
  localStorage.removeItem("adminToken");
};

// Create axios instance with admin auth header
export const adminApi = axios.create({
  baseURL: API,
});

// Add auth header to all requests
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken();
  if (token) {
    config.headers["X-Admin-Token"] = token;
  }
  return config;
});

// Handle 401 errors
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      logoutAdmin();
      window.location.href = "/admin/login";
    }
    return Promise.reject(error);
  }
);

// Verify admin token
export const verifyAdminToken = async () => {
  try {
    const token = getAdminToken();
    if (!token) return false;
    
    await adminApi.get("/admin/verify");
    return true;
  } catch (error) {
    logoutAdmin();
    return false;
  }
};
